
export default function AboutSection() {
  return (
    <section id="sobre-nosotros" className="py-20 bg-white">
      <div className="container mx-auto px-4">
        <div className="max-w-6xl mx-auto">
          <div className="text-center mb-16">
            <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6">
              Sobre RENABACH
            </h2>
            <p className="text-xl text-gray-600 max-w-3xl mx-auto">
              Una iniciativa colaborativa que nace del Primer Encuentro Nacional de Programas de 
              Bachillerato para fortalecer la educación superior en Chile
            </p>
          </div>

          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center mb-16">
            <div>
              <img 
                src="/images/757d3e1418bc52633b70b377c7282c4f.jpg"
                alt="Encuentro Nacional de Bachilleratos"
                className="rounded-2xl shadow-2xl object-cover w-full h-96"
              />
            </div>
            <div>
              <h3 className="text-3xl font-bold text-gray-900 mb-6">
                Nuestro Origen
              </h3>
              <p className="text-lg text-gray-700 mb-6 leading-relaxed">
                RENABACH surge del <strong>Primer Encuentro Nacional de Programas de Bachillerato</strong>, 
                desarrollado el 21 de noviembre de 2024 en la Universidad de Santiago de Chile, donde las 
                universidades participantes manifestaron su voluntad de articularse para fortalecer vínculos 
                y abrir nuevas oportunidades de colaboración.
              </p>
              <p className="text-lg text-gray-700 leading-relaxed">
                Respetamos las distintas estructuras de gobernanza, temporalidades y enfoques temáticos 
                de cada institución, creando un espacio de diálogo constructivo y colaboración académica.
              </p>
            </div>
          </div>

          <div className="bg-gradient-to-r from-blue-50 to-indigo-50 rounded-3xl p-8 md:p-12 mb-16">
            <h3 className="text-3xl font-bold text-gray-900 mb-8 text-center">
              Nuestros Principios Fundamentales
            </h3>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
              <div className="flex items-start space-x-4">
                <div className="w-12 h-12 bg-blue-600 rounded-xl flex items-center justify-center flex-shrink-0">
                  <i className="ri-lightbulb-line text-white text-xl"></i>
                </div>
                <div>
                  <h4 className="text-xl font-semibold text-gray-900 mb-3">Formación Integral</h4>
                  <p className="text-gray-700">
                    Promovemos la formación integral y ética de las personas, desarrollando 
                    todas las dimensiones del ser humano.
                  </p>
                </div>
              </div>
              
              <div className="flex items-start space-x-4">
                <div className="w-12 h-12 bg-blue-600 rounded-xl flex items-center justify-center flex-shrink-0">
                  <i className="ri-brain-line text-white text-xl"></i>
                </div>
                <div>
                  <h4 className="text-xl font-semibold text-gray-900 mb-3">Pensamiento Crítico</h4>
                  <p className="text-gray-700">
                    Orientamos hacia el desarrollo del pensamiento autónomo y crítico, 
                    fundamental para la vida académica y profesional.
                  </p>
                </div>
              </div>
              
              <div className="flex items-start space-x-4">
                <div className="w-12 h-12 bg-blue-600 rounded-xl flex items-center justify-center flex-shrink-0">
                  <i className="ri-team-line text-white text-xl"></i>
                </div>
                <div>
                  <h4 className="text-xl font-semibold text-gray-900 mb-3">Participación Activa</h4>
                  <p className="text-gray-700">
                    Incentivamos la participación y aporte activo en los distintos 
                    ámbitos de la vida en sociedad.
                  </p>
                </div>
              </div>
              
              <div className="flex items-start space-x-4">
                <div className="w-12 h-12 bg-blue-600 rounded-xl flex items-center justify-center flex-shrink-0">
                  <i className="ri-star-line text-white text-xl"></i>
                </div>
                <div>
                  <h4 className="text-xl font-semibold text-gray-900 mb-3">Desarrollo de Talentos</h4>
                  <p className="text-gray-700">
                    Reconocemos y potenciamos los diversos talentos, intereses y 
                    capacidades de cada estudiante.
                  </p>
                </div>
              </div>
            </div>
          </div>

          <div className="text-center">
            <div className="bg-blue-600 text-white p-8 rounded-2xl max-w-4xl mx-auto">
              <h3 className="text-2xl font-bold mb-4">Marco Legal</h3>
              <p className="text-lg leading-relaxed">
                Nuestro trabajo se encuentra en sintonía con lo establecido en el <strong>Título I de la 
                Ley de Educación Superior N° 21.091 de 2018</strong>, que establece que la educación superior 
                "busca la formación integral y ética de las personas, orientada al desarrollo del pensamiento 
                autónomo y crítico".
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
